const CODE_DOWN = "ArrowDown";
const CODE_END = "End";
const CODE_HOME = "Home";
const CODE_PAGEDOWN = "PageDown";
const CODE_PAGEUP = "PageUp";
const CODE_UP = "ArrowUp";
const RX_UNDERSCORE = /_/g;
const RX_LOWER_UPPER = /([a-z])([A-Z])/g;
const RX_NUMBER = /^[0-9]*\.?[0-9]+$/;
const RX_START_SPACE_WORD = /(\s|^)(\w)/g;
const RX_FIRST_START_SPACE_WORD = /(\s|^)(\w)/;
const RX_SPACE_SPLIT = /\s+/;
const RX_HASH = /^#/;
const RX_HASH_ID = /^#[A-Za-z]+[\w\-:.]*$/;
const RX_REGEXP_REPLACE = /[-/\\^$*+?.()|[\]{}]/g;
const RX_SPACES = /[\s\uFEFF\xA0]+/g;
export {
  CODE_UP as C,
  RX_NUMBER as R,
  RX_UNDERSCORE as a,
  RX_LOWER_UPPER as b,
  RX_FIRST_START_SPACE_WORD as c,
  RX_SPACES as d,
  RX_START_SPACE_WORD as e,
  RX_REGEXP_REPLACE as f,
  CODE_DOWN as g,
  CODE_PAGEUP as h,
  CODE_PAGEDOWN as i,
  CODE_HOME as j,
  CODE_END as k,
  RX_SPACE_SPLIT as l,
  RX_HASH_ID as m,
  RX_HASH as n
};
//# sourceMappingURL=constants-BdrZaBP8.mjs.map
